import { v4 as uuidv4 } from 'uuid';
import EnvStore from './env';
import ErrorsStore from './errors';
import LanguageStore from './language';
import SchedulesStore from './schedules';
import SubscriptionsStore from './subscriptions';
import ProfileStore from './profile';
import PublisherStore from './publisher';

export { useEnvStore } from './env';
export { useErrorsStore } from './errors';
export { useLanguageStore } from './language';
export { useSchedulesStore } from './schedules';
export { useSubscriptionsStore } from './subscriptions';
export { useProfileStore } from './profile';
export { usePublisherStore } from './publisher';

window.env = process.env.REACT_APP_ENV_VAR;

if (window.env === 'prod') {
    console.log = () => {};
}

const uniqueTraceId = uuidv4();
const envStore = new EnvStore();
envStore.Environment = window.env;
envStore.traceId = uniqueTraceId;

const errorsStore = new ErrorsStore();
const languageStore = new LanguageStore();
const schedulesStore = new SchedulesStore();
const subscriptionsStore = new SubscriptionsStore();
const profileStore = new ProfileStore();
const publisherStore = new PublisherStore();

envStore.mountStores({
    errorsStore,
    languageStore,
    schedulesStore,
    subscriptionsStore,
    profileStore,
    publisherStore,
});

window.envStore = envStore;

const models = {
    envStore,
    errorsStore,
    languageStore,
    schedulesStore,
    subscriptionsStore,
    profileStore,
    publisherStore,
};

export default models;
